import React, { Component } from "react";

export class HelpFooter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            message: props.message,
        };
    }
  render() {
    return (
      <React.Fragment>
            {this.state.message}{" "}
            <button href="" className='LinkButton a-icon' onClick={() => {
                let url = "https://cloudcover365.virtualdcs.co.uk/helpme/login.html";
                window.open(url, '_blank');
            }}
            style={{ marginLeft: "5px" }}>
            Help
          </button>
      </React.Fragment>
    );
  }
}
